<script>
  import * as d3 from "d3";
  import crossfilter from "crossfilter2";

  import ZipMap from "./ZipMap.svelte";
  import ClusterMap from "./ClusterMap.svelte";
  import Histogram from "./Histogram.svelte";
  import StarwoodMap from "./StarwoodMap.svelte";

  import MultiSelect from "./MultiSelect.svelte";
  import Checkbox from "./Checkbox.svelte";
  import Table from "./Table.svelte";
  import DatePicker from "./DatePicker.svelte";

  import Airtable from "./Airtable.svelte"

  export let atl_zips = [];
  export let state_zip_geojson;
  export let data = [];
  export let starwoodData = [];
  export let countiesVector;

  export let airtable_original = [];
  export let fulton_2019 = [];

  let total_streets = Array.from(d3.group(data, (d) => d.street)).length;
  let total_zips = Array.from(d3.group(data, (d) => d.zip)).length;

  let evictions = [...data];
  // let filteredStarwoodData = [...starwoodData];

  let [startDate, endDate] = d3.extent(data, (d) => new Date(d.filingdate));

  let selected_zips = atl_zips;
  let selected_counties = ["Clayton", "Cobb", "DeKalb", "Fulton", "Gwinnett"];

  let address_table = ["Street", "Count"];

  let streets_data = Array.from(d3.group(evictions, (d) => d.street));
  let street_names = streets_data.map((d) => d[0]);
  let selected_streets = streets_data.map((d) => d[0]);

  // Airtable data variables
  let airtable = [...airtable_original];
  let total_airtab_streets = airtable.length;
  let airtab_street_names = airtable.map((d) => d["Address"]);
  let selected_airtab_streets = airtable.map((d) => d["Address"]);

  var cf = crossfilter(data);
  var countiesDimension = cf.dimension(function (d) {
    return d.county;
  });
  var zipsDimension = cf.dimension(function (d) {
    return d.zip;
  });
  var streetsDimension = cf.dimension(function (d) {
    return d.street;
  });
  var dateDimension = cf.dimension(function (d) {
    return new Date(d.filingdate);
  });

  let selected_years = [2017, 2018, 2019, 2020, 2021];

  $: if (selected_counties) {
    countiesDimension.filter(function (d) {
      return selected_counties.indexOf(d) > -1;
    });
    evictions = countiesDimension.top(Infinity);
  }

  $: if (selected_zips) {
    zipsDimension.filter(function (d) {
      return selected_zips.indexOf(d) > -1;
    });
    evictions = zipsDimension.top(Infinity);
  }

  $: if (selected_streets) {
    streetsDimension.filter(function (d) {
      return selected_streets.indexOf(d) > -1;
    });
    evictions = streetsDimension.top(Infinity);
  }

  $: if (selected_airtab_streets) {
    airtable = airtable_original.filter(d => selected_airtab_streets.includes(d["Address"]))
  }

  $: if (startDate) {
    dateDimension.filter(function (d) {
      return d > startDate && d < endDate;
    });
    evictions = dateDimension.top(Infinity);
  }

  $: if (endDate) {
    dateDimension.filter(function (d) {
      return d > startDate && d < endDate;
    });
    evictions = dateDimension.top(Infinity);
  }

  // $: if (selected_years) {
  //   // Deep clone, [...starwoodData] is deep but only top-level
  //   let cloned = JSON.parse(JSON.stringify(sfrData));
  //   for (let address of cloned) {
  //     address.events = address.events.filter((event) =>
  //       selected_years.includes(dayjs(event["File.Date"]).year())
  //     );
  //   }
  //   cloned = cloned.filter((a) => a.events.length > 0);
  //   filteredSfrData = cloned;
  // }

  const onStartDateChange = (d) => {
    if (d.detail > endDate) {
      return;
    }
    startDate = d.detail;
  };

  const onEndDateChange = (d) => {
    if (d.detail < startDate) {
      return;
    }
    endDate = d.detail;
  };
</script>

<div>
  <div id="atl">
    <div class="maps">
      <ZipMap {state_zip_geojson} {evictions} />
      <ClusterMap {evictions} />
    </div>
    <div class="controlPanel">
      <h2>Address-Based Evictions Tracker</h2>
      <p id="bodyText">
        Eviction data provided by Atlanta Regional Commission, The Federal
        Reserve Bank, Georgia Tech and Dr. Elora Raymond. Application built by
        Grace Guo, Phillip Walker Carnell, Jordan Taylor, and Anh-Ton Tran.
      </p>
      <div id="datePanel">
        <h3>Search by File Date</h3>
        <div id="dateSelect">
          <DatePicker
            on:datechange={onStartDateChange}
            selected={startDate}
            isAllowed={(date) => {
              return true;
            }}
          />
          <p style="font-size:12px;margin:0px 15px 0px 15px">to</p>
          <DatePicker
            on:datechange={onEndDateChange}
            selected={endDate}
            isAllowed={(date) => {
              return true;
            }}
          />
        </div>
      </div>
      <div>
        <MultiSelect
          key="zips"
          options={atl_zips}
          total={105}
          bind:selected={selected_zips}
          title="Search by ZIP Code"
        />
      </div>
      <div>
        <h3>Search by County</h3>
        <Checkbox
          options={["Clayton", "Cobb", "DeKalb", "Fulton", "Gwinnett"]}
          bind:selected={selected_counties}
        />
      </div>
      <div>
        <MultiSelect
          key="streets"
          options={street_names}
          total={total_streets}
          bind:selected={selected_streets}
          title="Search by Street Address"
        />
      </div>
      <div>
        <Table headers={address_table} {evictions} />
      </div>
    </div>
  </div>
  <Histogram {atl_zips} {state_zip_geojson} {evictions} />
  <div id="sfr">
    <div class="maps">
      <!-- <StarwoodMap {filteredStarwoodData} /> -->
      <StarwoodMap {starwoodData} {countiesVector} />
    </div>
    <div class="controlPanel">
      <h2>Potential Starwood Capital Properties Based on Eviction Data</h2>
      <p id="bodyText">
        This visualization displays properties in DeKalb, Fulton, Chatham,
        Macon, Bibb, Henry, Clayton, Gwinnett, and Cobb Counties where the
        plaintiff was listed as a Starwood Capital affiliate. The data comes
        from two data sets. First, Private Equity Stakeholder Project (PESP)
        scraped data from LexisNexis using a query that identified properties
        where the owner shared a corporate home office. This yielded 523
        properties. Second, PESP also provided a master list of known naming
        conventions for various private equity and corporate landholders. We
        took the names associated with Starwood Capital Group in Georgia and
        cross referenced it with court eviction data that Dr. Elora Raymond
        provided. This provided an additional 540 addresses. The total number of
        known Starwood Capital Group properties in DeKalb, Fulton, Chatham,
        Macon, Bibb, Henry, Clayton, Gwinnett, and Cobb Counties is 1063.
      </p>
      <!-- <h3>Search by File Date</h3>
      <Checkbox
        options={[2017, 2018, 2019, 2020, 2021]}
        colors={["#49F1FC", "#EB5FC9", "#11FA8A", "#7289E6", "#F59C46"]}
        bind:selected={selected_years}
      /> -->
    </div>
  </div>
  <div id="airtab">
    <div class="maps">
      <Airtable {airtable} {fulton_2019} />
    </div>
    <div class="airtab_controlPanel">
      <div>
        <MultiSelect
          key="airtab_streets"
          options={airtab_street_names}
          total={total_airtab_streets}
          bind:selected={selected_airtab_streets}
          title="Search by Street Address"
        />
      </div>
    </div>
  </div>
</div>

<style>
  #atl,
  #sfr {
    display: flex;
    flex-direction: horizontal;
  }

  .maps {
    width: 70vw;
  }

  .controlPanel {
    width: 25vw;
    margin-top: 25px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  #dateSelect {
    display: flex;
    align-items: center;
  }

  #bodyText {
    margin-top: 0px;
    margin-bottom: 0px;
    font-size: 10px;
  }

  #airtab {
    display: flex
  }
</style>
